var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{staticClass:"text-center",attrs:{"span":24}},[_c('h1',[_vm._v("Coming soon!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }